import React, { Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Star } from 'lucide-react';
import { Experience } from '../types/Experience';
import * as Icons from 'lucide-react';
interface FavoritesModalProps {
  isOpen: boolean;
  onClose: () => void;
  favorites: Experience[];
  onSelectExperience: (id: string) => void;
}
export function FavoritesModal({
  isOpen,
  onClose,
  favorites,
  onSelectExperience
}: FavoritesModalProps) {
  const handleExperienceClick = (id: string) => {
    onSelectExperience(id);
    onClose();
  };
  return <AnimatePresence data-id="element-159">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div className="fixed inset-0 bg-black/20 z-40" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} onClick={onClose} data-id="element-160" />

          {/* Modal */}
          <motion.div className="fixed bottom-0 left-0 right-0 bg-white rounded-t-2xl shadow-2xl z-50 max-h-[70vh] flex flex-col" initial={{
        y: '100%'
      }} animate={{
        y: 0
      }} exit={{
        y: '100%'
      }} transition={{
        duration: 0.3,
        ease: [0.4, 0, 0.2, 1]
      }} data-id="element-161">
            {/* Header */}
            <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100" data-id="element-162">
              <div className="flex items-center gap-2" data-id="element-163">
                <Star size={18} style={{
              color: '#6C083B'
            }} strokeWidth={1.5} data-id="element-164" />
                <h2 className="text-sm font-medium text-gray-900" data-id="element-165">
                  Esperienze preferite
                </h2>
              </div>
              <button onClick={onClose} className="p-2 -mr-2 text-gray-400 hover:text-gray-900 transition-colors" data-id="element-166">
                <X size={18} strokeWidth={1.5} data-id="element-167" />
              </button>
            </div>

            {/* Content */}
            <div className="flex-1 overflow-y-auto px-5 py-4" data-id="element-168">
              {favorites.length === 0 ? <div className="text-center py-12" data-id="element-169">
                  <Star size={48} className="mx-auto mb-3 text-gray-300" strokeWidth={1.5} data-id="element-170" />
                  <p className="text-sm text-gray-500 mb-1" data-id="element-171">
                    Nessuna esperienza preferita
                  </p>
                  <p className="text-xs text-gray-400" data-id="element-172">
                    Aggiungi le tue esperienze preferite per accedervi
                    rapidamente
                  </p>
                </div> : <div className="space-y-2" data-id="element-173">
                  {favorites.map(experience => {
              const IconComponent = experience.icon ? (Icons as any)[experience.icon] || Icons.Wine : Icons.Wine;
              return <button key={experience.id} onClick={() => handleExperienceClick(experience.id)} className="w-full flex items-center gap-3 p-3 rounded-lg border border-gray-100 hover:border-gray-200 transition-colors text-left" data-id="element-174">
                        <IconComponent size={18} style={{
                  color: '#6C083B'
                }} strokeWidth={1.5} data-id="element-175" />
                        <div className="flex-1 min-w-0" data-id="element-176">
                          <h4 className="text-sm text-gray-900 mb-0.5" data-id="element-177">
                            {experience.name}
                          </h4>
                          <p className="text-xs text-gray-500" data-id="element-178">
                            {experience.bottleCount}{' '}
                            {experience.bottleCount === 1 ? 'bottiglia' : 'bottiglie'}
                          </p>
                        </div>
                        <Star size={16} className="text-gray-300 fill-current" strokeWidth={1.5} data-id="element-179" />
                      </button>;
            })}
                </div>}
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}